module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 1",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 2",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.3.0.0.box.610.744.803.379.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.3.0.0.box.858.744.306.40.q.80"
    }
  }, [_vm._v("Other books")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.3.0.1.box.704.803.613.50.q.50"
    }
  }, [_vm._v("by Jude W. Theriot, CCP")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.0.2.box.794.900.435.49.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cajun ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Quick ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1992) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.0.3.box.610.958.803.50.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("American ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Light ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cuisine ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1988) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.0.4.box.740.1018.543.49.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("La ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.0.0"
    }
  }), _vm._v("Cuisine ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.5.0.0"
    }
  }), _vm._v("Cajun ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.7.0.0"
    }
  }), _vm._v("(1990) ")])]), _c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.0.5.box.615.1076.793.47.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _vm._v("La ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.0.0"
    }
  }), _vm._v("Meilleure ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.2.0"
    }
  }), _vm._v("de ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.4.0"
    }
  }), _vm._v("la ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.0.0"
    }
  }), _vm._v("Louisiane ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.6.0.0"
    }
  }), _vm._v("(1980) ")])]), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.7.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 4",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 5",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.0.0.box.313.736.1396.870.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.6.0.0.box.315.736.1394.222.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Madolyn ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("McCoy, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("personal ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("secretary ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("over ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("twelve ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("years: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("always ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("appreciate ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dedication, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("loyalty, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("friendship. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("could ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("have ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("found ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("more ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("valuable ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("competent ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("individual ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("anywhere ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("earth. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Thanks ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("do ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("me. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.6.0.1.box.314.1032.1393.281.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Virginia ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Rue, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("good ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("friend, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("who ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("kept ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pushing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("me ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("write ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("book: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("You ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("told ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("me ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("weight ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("was ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("losing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("good ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("food ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("was ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("eating, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I'd ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("make ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("million ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("book. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("You ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("kept ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("telling ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("me ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("world ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("needed ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("book. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("You ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("even ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("started ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("taking ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ad")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("vance ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("orders! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("appreciate ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("enthusiasm ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("friendship. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.6.0.2.box.313.1386.1396.220.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _vm._v("Rose ")]), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Manuel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("LeBlanc ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carroll ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.2.0.0"
    }
  }), _vm._v("Patrick ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.0.0"
    }
  }), _vm._v("LeBlanc, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('i', [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.4.0.0"
    }
  }), _vm._v("parents-")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.6.0.0"
    }
  }), _vm._v("in-law, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.7.0.0"
    }
  }), _vm._v("their ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.8.0.0"
    }
  }), _vm._v("support ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.9.0.0"
    }
  }), _vm._v("through ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.10.0.0"
    }
  }), _vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.11.0.0"
    }
  }), _vm._v("tough ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.12.0.0"
    }
  }), _vm._v("times ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.13.0.0"
    }
  }), _vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _vm._v("parenting ")]), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wife ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("over ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.3.0.0"
    }
  }), _vm._v("twenty-one ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.4.0.0"
    }
  }), _vm._v("years. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.5.1.0"
    }
  }), _vm._v("appreciate ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.5.2.0"
    }
  }), _vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.6.0.0"
    }
  }), _vm._v("caring ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.7.0.0"
    }
  }), _vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("friendship. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.9.0.0.box.144.110.1642.2478.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic][subsumed][ocr errors][ocr errors][ocr errors][ocr errors][ocr errors][ocr errors][ocr errors][ocr errors][ocr errors]",
      "src": "data/content-0006.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.2"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b64423","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0007.vue
// module id = 54
// module chunks = 0